import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const supportedLanguages = ['pt-BR', 'en'];
const fallbackLanguage = 'pt-BR';

const detectedLanguage = () => {
  const languageSelected = localStorage.getItem('i18nextLng');

  const userLanguage =  !languageSelected ? navigator.language : languageSelected;
  return supportedLanguages.includes(userLanguage) ? userLanguage : fallbackLanguage;
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLanguages,
    lng: detectedLanguage(),
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
